import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ApprovalsRoutingModule } from './approvals-routing.module';
import { ApprovalsComponent } from './approvals.component';

@NgModule({
  imports: [
    CommonModule,
    ApprovalsRoutingModule,
  ],
  declarations: [ApprovalsComponent]
})
export class ApprovalsModule { }
